import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import {
    Card,
    Stack,
    Typography,
    CircularProgress,
    useMediaQuery,
    FormControl,
    Select,
    OutlinedInput,
    MenuItem,
    TextField,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from '@mui/material';
import ClearButton from 'src/components/shared/ClearButton';
import FilterButton from 'src/components/shared/FilterButton';
import AddEntityButton from 'src/components/shared/AddEntityButton';
import DynamicTable from 'src/components/shared/DynamicTable';
import CustomFilter from 'src/components/filter/CustomFilter';
import FilterViewButton from 'src/components/shared/FilterViewButton';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useLocalization } from 'src/context/LocalizationContext';
import Iconify from 'src/components/iconify';
import { CutomerVehicleApprovalModal } from 'src/modals/CutomerVehicleApprovalModal';
import QRModal from 'src/modals/QRModal';
import { tokenService } from 'src/services';
import Services from 'src/services/Services';
import moment from 'moment';
import { toast } from 'react-toastify';

export default function PetVehicles() {
    const poiID = tokenService.getUser().firstResponsibleOffice.id;
    const parsedUser = JSON.parse(localStorage.getItem('user'));

    const { language } = useLocalization();
    const [selected, setSelected] = useState([]);
    const [filterModal, setFilterModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [selectedStatus, setSelectedStatus] = useState([]);

    const [name, setName] = useState("");
    const [lastname, setLastname] = useState("");
    const [vehicleNo, setVehicleNo] = useState("");


    const [qrModalOpen, setQrModalOpen] = useState(false);
    const handleOpenQR = () => setQrModalOpen(true)
    const handleCloseQR = () => setQrModalOpen(false)
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const [rows, setRows] = useState([]);
    const [mallTitle, setMallTitle] = useState("");
    const [willConfirmOrders, setWillConfirmOrders] = useState([]);
    const [originalData, setOriginalData] = useState([]);

    const [confirmCompleteOpen, setConfirmCompleteOpen] = useState(false);
    const [pendingComplete, setPendingComplete] = useState(null);


    const isMobile = useMediaQuery('(max-width:768px)');

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 0;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };

    const StatusList = [
        {
            label: "Tamamlandı",
            id: "1"
        },
        {
            label: "Ödeme Bekleniyor",
            id: "payment-waiting"
        },
        {
            label: "Fiziksel POS Onay Bekleniyor",
            id: "payment-waiting-physical"
        },
        {
            label: "Nakit Onay Bekleniyor",
            id: "payment-waiting-cash"
        },
        {
            label: "Süre Aşıldı",
            id: "99"
        },
        {
            label: "Onay Bekliyor",
            id: "3"
        },
        {
            label: "Onaylandı",
            id: "4"
        },
    ];

    const handleModal = () => {
        setFilterModal(true);
    };

    const handleCloseModal = () => {
        setFilterModal(false);
    };

    const handleCheckboxChange = (event, id, row) => {
        if (event.target.checked) {
            setSelected(prev => [...prev, id]);
        } else {
            setSelected(prev => prev.filter(item => item !== id));
        }
    };

    const handleSelectAll = (event) => {
        if (event.target.checked) {
            setSelected(rows.map(row => row.id));
        } else {
            setSelected([]);
        }
    };

    const handleChange = (event) => {
        const {
            target: { value },
        } = event;
        setSelectedStatus(value);
    };

    const getRows = () => {
        setIsLoading(true);
        let mall = "";
        Services.GetPoiDetails(parsedUser.token, poiID)
            .then(res => {
                if (res.data.status) {
                    mall = res.data.result.mallTitle;
                    setMallTitle(mall);
                }
                return Services.GetPetCarOrders(parsedUser.token, poiID);
            })
            .then(response => {
                console.log(response.data.result)
                const mapped = response.data.result.map((item, idx) => {
                    const confirmed = Number(item.confirmedDateTime);
                    const durationSec = Number(item.duration);
                    const endByConfirmed =
                        Number.isFinite(confirmed) &&
                            confirmed > 0 &&
                            Number.isFinite(durationSec) &&
                            durationSec > 0
                            ? confirmed + durationSec
                            : 0;
                    const end = endByConfirmed > 0 ? endByConfirmed : Number(item.willDeliverDateTime);
                    const nowUnix = moment().unix();
                    const isOverdue =
                        item.status === "4" &&
                        Number.isFinite(end) &&
                        end > 0 &&
                        nowUnix > end;
                    const isPaymentWaiting = item.isPaid !== "1";
                    return {
                        id: item.id,
                        no: idx + 1,
                        conversationID: item.paymentID || item.paymentId || "-",
                        requestID: item.requestID || "-",
                        checkroomInfo: mall,
                        name: item.name,
                        lastname: item.lastname,
                        vehicleID: item.vehicleID || "-",
                        packageCount: 1,
                        totalPrice: item.price ? `${item.price} ${item.currency}` : "-",
                        rentalDuration: item.durationText,
                        createdDateTime: moment
                            .unix(Number(item.createdDateTime))
                            .format("DD.MM.YYYY HH:mm"),
                        createdDateTimeTs: Number(item.createdDateTime),
                        confirmedDateTime: confirmed > 0 ? moment.unix(confirmed).format("DD.MM.YYYY HH:mm") : "-",
                        confirmedDateTimeTs: confirmed > 0 ? confirmed : 0,
                        status: item.status,
                        paymentType: item.paymentType,
                        displayStatus: isPaymentWaiting ? "payment-waiting" : (isOverdue ? "99" : item.status),
                        item: item,
                        isPaid: item.isPaid
                    };
                });
                const isPendingCustomer = (x) =>
                    x.status === "3" &&
                    (x.isPaid === "1" || ["physical-pos", "cash"].includes(x.paymentType));
                setWillConfirmOrders(mapped.filter(isPendingCustomer));
                setRows(mapped.filter(x =>
                    x.isPaid === "1" ||
                    (x.displayStatus === "payment-waiting" && ["physical-pos", "cash"].includes(x.paymentType))
                ));
                setOriginalData(mapped);
            })
            .catch(err => console.error(err))
            .finally(() => setIsLoading(false));
    }

    const handleCompleteRequest = (requestID, poiID) => {

        Services.PetKidSetRequestComplete(parsedUser.token, requestID, poiID)
            .then(res => {
                if (res.data.status) {
                    getRows()
                } else {
                    toast.error('İşlem tamamlanırken bir sorunla karşılaşıldı.');
                }
            })
            .catch(err => console.log(err));
    }

    const openCompleteConfirm = (requestID, poiID) => {
        setPendingComplete({ requestID, poiID });
        setConfirmCompleteOpen(true);
    };

    const closeCompleteConfirm = () => {
        setConfirmCompleteOpen(false);
        setPendingComplete(null);
    };

    const confirmCompleteRequest = () => {
        if (!pendingComplete?.requestID || !pendingComplete?.poiID) {
            closeCompleteConfirm();
            return;
        }
        handleCompleteRequest(pendingComplete.requestID, pendingComplete.poiID);
        closeCompleteConfirm();
    };

    const handleFilter = () => {
        let filtered = originalData;

        if (startDate) {
            const start = moment(startDate).startOf('day').unix();
            filtered = filtered.filter(row => Number(row.confirmedDateTimeTs || 0) >= start);
        }

        if (endDate) {
            const end = moment(endDate).endOf('day').unix();
            filtered = filtered.filter(row => Number(row.confirmedDateTimeTs || 0) <= end);
        }

        if (selectedStatus.length > 0) {
            const statusIds = selectedStatus.map(s => s.id);
            filtered = filtered.filter((row) => {
                const statusValue = row.displayStatus ?? row.status;
                const isPaymentWaiting =
                    statusIds.includes('payment-waiting') &&
                    row.displayStatus === "payment-waiting" &&
                    !["physical-pos", "cash"].includes(row.paymentType);
                const isPaymentWaitingPhysical =
                    statusIds.includes('payment-waiting-physical') &&
                    row.displayStatus === "payment-waiting" &&
                    row.paymentType === "physical-pos";
                const isPaymentWaitingCash =
                    statusIds.includes('payment-waiting-cash') &&
                    row.displayStatus === "payment-waiting" &&
                    row.paymentType === "cash";
                const matchesStatus = statusIds.includes(statusValue);
                return isPaymentWaiting || isPaymentWaitingPhysical || isPaymentWaitingCash || matchesStatus;
            });
        }

        if (name.trim() !== '') {
            filtered = filtered.filter(row => row.name?.toLowerCase().includes(name.toLowerCase()));
        }

        if (lastname.trim() !== '') {
            filtered = filtered.filter(row => row.lastname?.toLowerCase().includes(lastname.toLowerCase()));
        }

        if (vehicleNo.trim() !== '') {
            filtered = filtered.filter(row => row.vehicleID?.toLowerCase().includes(vehicleNo.toLowerCase()));
        }

        setRows(filtered);
    };

    const handleClearFilter = () => {
        setStartDate(null);
        setEndDate(null);
        setSelectedStatus([]);
        setName("");
        setLastname("");
        setVehicleNo("");
        setRows(originalData.filter(x =>
            x.isPaid === "1" ||
            (x.displayStatus === "payment-waiting" && ["physical-pos", "cash"].includes(x.paymentType))
        )); // geri dön
    };


    useEffect(() => {
        getRows()
    }, []);

    const statusLabels = {
        "1": "Tamamlandı",
        "payment-waiting": "Ödeme Bekleniyor",
        "99": "Süre Aşıldı",
        "3": "Onay Bekliyor",
        "4": "Onaylandı"
    };

    const commonStyle = {
        padding: '4px 12px',
        borderRadius: '6px',
        fontSize: 14,
        fontWeight: 500,
        fontFamily: 'Inter',
        marginRight: '6px',
    };

    const TABLE_HEAD = [
        // { id: 'checkbox', label: '', alignRight: false, sx: { width: '20px' } },
        { id: 'no', label: 'No', alignRight: false, sx: { width: '20px' } },
        { id: 'conversationID', label: 'Conversation ID', alignRight: false },
        { id: 'requestID', label: 'Sipariş ID', alignRight: false },
        { id: 'checkroomInfo', label: 'Konum Bilgisi', alignRight: false },
        { id: 'name', label: 'Ad', alignRight: false },
        { id: 'lastname', label: 'Soyad', alignRight: false },
        { id: 'vehicleID', label: 'Araç No', alignRight: false },
        { id: 'packageCount', label: 'A. Adedi', alignRight: false },
        {
            id: 'totalPrice',
            label: 'Ödenen Ücret',
            alignRight: false,
        },
        {
            id: 'createdDateTime',
            label: 'Talep Tarihi',
            alignRight: false,
            sortFunction: (row) => Number(row.createdDateTimeTs || 0),
        },
        {
            id: 'confirmedDateTime',
            label: 'Onaylanma Tarihi',
            alignRight: false,
            sortFunction: (row) => Number(row.confirmedDateTimeTs || 0),
        },
        {
            id: 'rentalDuration',
            label: 'Kiralama Süresi',
            alignRight: false,
        },
        {
            id: 'status',
            label: 'Durum',
            alignRight: false,
            format: (value, row) => {
                const statusValue = row.displayStatus ?? value;
                const label =
                    statusValue === "payment-waiting" && row.paymentType === "physical-pos"
                        ? "Fiziksel POS Onay Bekleniyor"
                        : statusValue === "payment-waiting" && row.paymentType === "cash"
                            ? "Nakit Onay Bekleniyor"
                        : (statusLabels[statusValue] ?? statusValue);
                let style = {};

                switch (statusValue) {
                    case "1":   // Tamamlandı
                        style = { backgroundColor: 'rgba(222,247,236,1)', color: 'rgba(3,84,63,1)' };
                        break;
                    case "payment-waiting":  // Fiziksel POS Onay Bekleniyor
                        style = { backgroundColor: 'rgba(255,243,205,1)', color: 'rgba(133,94,0,1)' };
                        break;
                    case "99":  // Süre Aşıldı
                        style = { backgroundColor: 'rgba(253,232,232,1)', color: 'rgba(155,28,28,1)' };
                        break;
                    case "3":   // Onay Bekliyor
                        style = { backgroundColor: 'rgba(255,243,205,1)', color: 'rgba(133,94,0,1)' };
                        break;
                    case "4":   // Onaylandı
                        style = { backgroundColor: 'rgba(217,234,251,1)', color: 'rgba(13,60,97,1)' };
                        break;
                    default:
                        style = { backgroundColor: 'rgba(237,235,254,1)', color: 'rgba(85,33,181,1)' };
                }

                return (
                    <span style={{ ...commonStyle, ...style, whiteSpace: 'pre' }}>
                        {label}
                    </span>
                );
            },
            sx: { width: '15%' },
        },
        {
            id: 'item',
            label: '',
            alignRight: false,
            format: (value, row) => {
                if (row.status === "4") {
                    return (
                        <Iconify
                            icon="fluent-mdl2:completed"
                            style={{ cursor: 'pointer' }}
                            color="rgba(156,163,175,1)"
                            onClick={() => openCompleteConfirm(row.item.requestID, row.item.poiID)}
                        />
                    )
                }
            },
            sx: { width: '20px' },
        },
    ];

    return (
        <>
            <Helmet>
                <title> Evcil Hayvan Araçları | Easy Point Panel </title>
            </Helmet>

            <Stack style={{ paddingInline: '25px' }}>
                <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                    mb={5}
                >
                    <Typography variant="h4" gutterBottom>
                        Evcil Hayvan Araçları
                    </Typography>
                    <AddEntityButton onClick={handleOpenQR} label={"QR OLUŞTUR"} icon={"ic:baseline-qrcode"} />
                </Stack>
                <Stack
                    direction="row"
                    justifyContent={isMobile ? 'space-between' : 'end'}
                    mb={5}
                    paddingX={2}
                >
                    {isMobile ? (
                        <FilterViewButton variant="contained" onClick={handleModal} />
                    ) : null}
                </Stack>
                <Card>
                    <div style={{
                        position: 'absolute',
                        right: '44px',
                        top: '15px',
                        flexDirection: 'row',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>

                        <span style={{ color: 'rgba(155, 154, 154, 1)', marginRight: '8px', display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
                            <Iconify icon={'ph:users-bold'} style={{ marginRight: '5px' }} /><span>Bekleyen Müşteri Talepleri:</span>
                        </span>

                        <Button variant="contained" onClick={handleOpen}
                            sx={{
                                backgroundColor: 'rgba(249, 250, 251, 1)',
                                border: '1px solid rgba(234, 236, 240, 1)',
                                color: 'rgba(52, 64, 84, 1)',
                                boxShadow: 'none',
                                fontWeight: '500',
                                '&:hover': {
                                    backgroundColor: 'rgba(249, 250, 251, 1)',
                                    border: '1px solid rgb(193, 194, 196)'
                                }
                            }}>
                            Talepler <span style={{ width: '21px', height: '21px', borderRadius: '100%', backgroundColor: 'rgba(255, 225, 225, 1)', color: 'rgba(219, 57, 57, 1)', alignItems: 'center', justifyContent: 'center', display: 'flex', marginLeft: '5px' }}>{willConfirmOrders.length}</span>
                        </Button>
                    </div>

                    <CustomFilter
                        modalType={'drawer'}
                        filterModal={filterModal}
                        handleCloseModal={handleCloseModal}
                    >
                        <Stack
                            direction="row"
                            alignItems="center"
                            justifyContent="flex-start"
                            paddingY={2}
                            paddingX={1}
                        >
                            <Stack
                                mr={1}
                                direction="column"
                                alignItems="flex-start"
                                justifyContent="flex-start"
                                sx={{ marginBottom: 2 }}
                                width="100%"
                                spacing={2}
                            >

                                <Stack direction="row" spacing={2} sx={{ width: '100%' }}>
                                    <FormControl sx={{ flex: 1 }}>
                                        <LocalizationProvider dateAdapter={AdapterMoment}>
                                            <DatePicker
                                                sx={{ flex: 1 }}
                                                format="DD/MM/YYYY"
                                                label={language.commons.labels.start_date}
                                                value={startDate}
                                                onChange={(newValue) => setStartDate(newValue)}
                                            />
                                        </LocalizationProvider>
                                    </FormControl>
                                    <FormControl sx={{ flex: 1 }}>
                                        <LocalizationProvider dateAdapter={AdapterMoment}>
                                            <DatePicker
                                                sx={{ flex: 1 }}
                                                format="DD/MM/YYYY"
                                                label={language.commons.labels.end_date}
                                                value={endDate}
                                                onChange={(newValue) => setEndDate(newValue)}
                                            />
                                        </LocalizationProvider>
                                    </FormControl>
                                </Stack>

                                <Stack direction="row" spacing={2} sx={{ width: '100%' }}>
                                    <FormControl sx={{ flex: 1 }}>
                                        <Select
                                            multiple
                                            displayEmpty
                                            value={selectedStatus}
                                            input={<OutlinedInput />}
                                            onChange={handleChange}
                                            renderValue={(selected) => {
                                                if (selected?.length === 0) {
                                                    return <em>{language.commons.status}</em>;
                                                }

                                                return selected.map((x) => x?.label).join(', ');
                                            }}
                                            MenuProps={MenuProps}
                                            inputProps={{ 'aria-label': 'Without label' }}
                                        >
                                            {StatusList.map((x) => (
                                                <MenuItem key={x.id} value={x}>
                                                    {x.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Stack>

                                <FormControl sx={{ flex: 1, minWidth: '100%' }}>
                                    <TextField
                                        label="Ad"
                                        variant="outlined"
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                        sx={{ flex: 1 }}
                                    />
                                </FormControl>

                                <FormControl sx={{ flex: 1, minWidth: '100%' }}>
                                    <TextField
                                        label="Soyad"
                                        variant="outlined"
                                        value={lastname}
                                        onChange={(e) => setLastname(e.target.value)}
                                        sx={{ flex: 1 }}
                                    />
                                </FormControl>

                                <FormControl sx={{ flex: 1, minWidth: '100%' }}>
                                    <TextField
                                        label="Araç No"
                                        variant="outlined"
                                        value={vehicleNo}
                                        onChange={(e) => setVehicleNo(e.target.value)}
                                        sx={{ flex: 1 }}
                                    />
                                </FormControl>

                            </Stack>
                        </Stack>
                        <Stack direction="row" spacing={1} justifyContent="center" alignItems="center">
                            <ClearButton onClick={handleClearFilter} />
                            <FilterButton onClick={handleFilter} />
                        </Stack>
                    </CustomFilter>

                    {isLoading ?
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                width: '100%',
                                padding: '50px',
                            }}
                        >
                            <CircularProgress size={24} color="inherit" />
                        </div>
                        :
                        <div style={{ marginTop: '50px' }}>
                            <DynamicTable
                                data={rows}
                                headers={TABLE_HEAD}
                                initialOrder={"confirmedDateTime"}
                                initalOrderDirection={"desc"}
                                isMobile={isMobile}
                                handleModal={handleModal}
                                handleCloseModal={handleCloseModal}
                            // selected={selected}
                            // handleCheckboxChange={handleCheckboxChange}
                            // handleSelectAll={handleSelectAll}
                            />
                        </div>

                    }
                </Card>
            </Stack>

            <QRModal
                open={qrModalOpen}
                qrLink={"https://qr.easypointapi.com/?chs=700x700&cht=qr&chl=https://easydesk.easypoint.com.tr/?poi=" + poiID}
                onClose={handleCloseQR}
            />

            <CutomerVehicleApprovalModal
                open={open}
                onClose={handleClose}
                data={willConfirmOrders}
                type={"pet-car"}
                getRows={getRows}
            />

            <Dialog open={confirmCompleteOpen} onClose={closeCompleteConfirm} maxWidth="xs" fullWidth>
                <DialogTitle>İşlem Onayı</DialogTitle>
                <DialogContent>
                    Bu işlemi tamamlamak istediğinizden emin misiniz
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeCompleteConfirm} variant="outlined">Vazgeç</Button>
                    <Button onClick={confirmCompleteRequest} variant="contained">Onayla</Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
